const productList = document.querySelector("[data-products-list]");
let currentObservedElement = null;
let intersectionObserver = null;
let isLoading = false;

// Function to trigger when second last child is visible
function onSecondLastChildVisible(entry) {
  if (isLoading) return;
  isLoading = true;

  const nextUrl = productList.getAttribute("data-next-url");
  if (!nextUrl) {
    console.warn("No next URL found.");
    return;
  }

  fetch(nextUrl)
    .then(response => response.text())
    .then(data => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, "text/html");

      const newItems = doc.querySelector("[data-products-list]");
      if (newItems && newItems.innerHTML.trim()) {
        productList.insertAdjacentHTML("beforeend", newItems.innerHTML);
        productList.setAttribute("data-next-url", newItems.getAttribute("data-next-url") || "");
        observeSecondLastChild(); // Observe new second last child after adding
      } else {
        console.warn("No new product items found in next page.");
      }
    })
    .catch(err => {
      console.error("Load more failed:", err);
    })
    .finally(() => {
      isLoading = false;
    });
}

// Create Intersection Observer once
function createIntersectionObserver() {
  if (!intersectionObserver) {
    intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          onSecondLastChildVisible(entry);
        }
      });
    }, {
      root: null,
      threshold: 0.1
    });
  }
}

// Observe the second last child only once
function observeSecondLastChild() {
  const children = productList?.children;
  if (!children || children.length < 2) return;

  const secondLastChild = children[children.length - 2];

  if (currentObservedElement !== secondLastChild) {
    if (currentObservedElement) {
      intersectionObserver.unobserve(currentObservedElement);
    }
    currentObservedElement = secondLastChild;
    intersectionObserver.observe(secondLastChild);
  }
}

// Optional: Watch for DOM changes to handle external mutations
function setupMutationObserver() {
  const mutationObserver = new MutationObserver(() => {
    observeSecondLastChild();
  });

  mutationObserver.observe(productList, {
    childList: true,
    subtree: false
  });
}

// Initialize everything
createIntersectionObserver();
observeSecondLastChild();
setupMutationObserver();
